import { Dashboard, AdsMyProperty } from '@/components';

export const MyAdsPage = () => (
  <Dashboard isSearch openLogIn>
    <AdsMyProperty />
  </Dashboard>
);
